<template>
  <v-card>
    <v-card-title>
      <span class="headline" data-test="form-title">{{ formTitle }}</span>
    </v-card-title>

    <v-card-text>
      <v-form>
        <v-container>
          <v-row >
            <v-col cols="12" md="8">
              <v-text-field 
                ref="title-input"
                v-model="news.title" 
                label="Titre" 
                required
                :error-messages="titleErrors"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field 
                prepend-inner-icon="account_box"
                v-model="news.author" 
                label="Auteur" 
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-select 
                v-model="news.type" 
                :items="types"
                item-text="label"
                item-value="value"
                label="Type" 
                filled
                :disabled="!!news.id"
              >
                <template v-slot:item="props">
                  <v-icon class="mr-4">{{props.item.icon}}</v-icon>
                  <span>{{props.item.label}}</span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" v-if="news.type === 'image-cover' || news.type === 'image'">
              <v-img class="mb-4" v-if="imagePreview" :src="imagePreview" height="150px" aspect-ratio="16/9" contain></v-img>
              <input type="file" @change="handleFile" ref="file" accept="image/*">
            </v-col>
            <v-col cols="12" v-if="news.type === 'image-cover'">
              <v-textarea 
                ref="description-textarea"
                v-model="news.description" 
                label="Texte de la couverture" 
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <MallSelector v-model="news.mall" outline :label="$t('Documents.Form.mall')" :errorMessages="mallErrors"/>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-switch v-model="news.isActive" label="Active" color="primary"></v-switch>
      <v-spacer></v-spacer>
      <v-btn ref="cancel-btn" color="grey" text @click="cancel">Annuler</v-btn>
      <v-btn ref="save-btn" color="primary" text @click="save">Sauvegarder</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import FilesPathHelpersMixin from '@/mixins/FilesPathHelpersMixin'
import MallSelector from '@/components/Utils/MallSelector'
export default {
  name: 'NewsEditor',
  components: { MallSelector },
  mixins: [FilesPathHelpersMixin],
  props: {
    defaultNews: {type: Object, required: false},
    defaultFormTitle: {type: String, required: false}
  },
  data: () => ({
    news: null,
    default: {
      title: '',
      author: '',
      description: '',
      type: 'image',
      isActive: false,
      mall: null
    },
    types: [
      {label: 'Image simple', value: 'image', icon: 'image'},
      {label: 'Image avec couverture', value: 'image-cover', icon: 'photo_album'}
    ],
    imageFile: null
  }),
  computed: {
    formTitle () {
      return this.defaultFormTitle || (this.news.id ? 'Modification' : 'Création')
    },
    imagePreview () {
      return this.imageFile ? URL.createObjectURL(this.imageFile) : this.getNewsImgPath(this.news.imageName)
    },
    titleErrors () {
      const errors = []
      if (!this.$v.news.title.$dirty) return errors
      !this.$v.news.title.required && errors.push('Titre requis')
      return errors
    },
    mallErrors () {
      const errors = []
      if (!this.$v.news.mall.$dirty) return errors
      !this.$v.news.mall.required && errors.push(this.$t('Global.Common.required'))
      return errors
    }
  },
  watch: {
    defaultNews () {
      this.resetForm()
    }
  },
  validations: {
    news: {
      title: { required },
      mall: { required }
    }
  },
  methods: {
    handleFile () {
      this.imageFile = this.$refs.file.files[0]
    },
    init () {
      this.news = this.defaultNews ? {...this.defaultNews} : {...this.default}
    },
    save () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$emit('save', {...this.news, file: this.imageFile})
      } else {
        this.$emit('invalid-form')
      }
    },
    cancel () {
      this.$emit('cancel')
      this.resetForm()
    },
    resetForm () {
      this.init()
      this.$v.$reset()
    }
  },
  created () {
    this.init()
  }
}
</script>